<span class='integer-value'>{{ value }}</span>
<!--
<span>
  <span class='integer-value'>{{ integerValue }}</span>
  <span class='cents-value'>{{ centsValue }}</span>
</span>
-->
